import {Component, Input, TemplateRef, ViewChild} from '@angular/core';
import {NbWindowRef, NbWindowService} from '@nebular/theme';
import {Debt} from '../../class/debt';
import {WelfareResultService} from '../../service/welfare-result.service';
import {Util} from '../../util/util';
import {BaseResultComponent} from '../result/base-result/base-result.component';

@Component({
  selector: 'app-debt',
  templateUrl: './debt.component.html',
  styleUrls: ['./debt.component.css']
})
export class DebtComponent extends BaseResultComponent {

  @Input()
  debt: Debt;

  currentYear;
  inputYear: number;
  showError = false;

  windoRef: NbWindowRef;

  @ViewChild('contentTemplate') contentTemplate: TemplateRef<any>;

  constructor(windowService: NbWindowService, private welfareService: WelfareResultService) {
    super(windowService);
  }

  calc() {
    this.debt.debtYear = this.debt.monthRate * 12;
    this.debt.debtRes = this.debt.debtYear * this.debt.expireIn;
    this.debt.expireInYear = Util.getCurrentYear() + this.debt.expireIn;
  }

  openWindow() {
    this.showError = false;
    this.windoRef = this.windowService.open(this.contentTemplate, {title: `Window`});
  }

  expireFromYear() {
    if (this.inputYear > this.currentYear) {
      this.debt.expireIn = (this.inputYear - this.currentYear);
      this.windoRef.close();
    } else {
      this.showError = true;
    }
    this.calc();
  }

  deleteDebt() {
    this.welfareService.removeDebt(this.debt);
  }

  onResultImpl() {
    this.calc();
  }

  ngOnInitImpl() {
    this.currentYear = Util.getCurrentYear();
  }
}
